import jsonToView from '../../api/json-to-view';
import setMarkersFilteringOn from './markers-filter';

export default function buildCategoryFiltering(
  data,
  allMarkers,
  searchedPlaceLat,
  searchedPlaceLng,
  buildList
) {
  if (!data || !data.features) {
    return;
  }

  const orderDataBy = prop => (a, b) => {
    if (a[prop] > b[prop]) {
      return 1;
    }
    return -1;
  };

  data.features.sort(orderDataBy('category'));

  setMarkersFilteringOn(data, allMarkers, buildList, searchedPlaceLat, searchedPlaceLng);

  const categories = document.querySelector('[data-child-module="Locator__Categories"]');
  if (categories) {
    data.features.forEach(categoryItem => {
      const listItem = document.createElement('li');
      listItem.classList.add('c-location-filters__item');

      const templateView = 'LocatorCategoryFilter';
      jsonToView(categoryItem, templateView).then(result => {
        listItem.innerHTML = result;
      });

      categories.appendChild(listItem);
    });
  }
}
